var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lg:min-h-[607px]" }, [
    _c(
      "div",
      {
        staticClass:
          "w-full flex gap-24 lg:gap-0 flex-col lg:flex-row justify-between items-center mb-24 lg:mb-75"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "job-filters flex flex-wrap gap-y-16 lg:gap-y-0 gap-x-24 w-full"
          },
          [
            _c("form-select", {
              staticClass: "w-full min-w-[200px] lg:max-w-[250px] text-orange",
              attrs: {
                placeholder: "Zoek op dienst",
                options: _vm.sectorOptions
              },
              model: {
                value: _vm.sector,
                callback: function($$v) {
                  _vm.sector = $$v
                },
                expression: "sector"
              }
            }),
            _vm._v(" "),
            _c("form-select", {
              staticClass: "w-full min-w-[200px] lg:max-w-[250px] text-orange",
              attrs: {
                placeholder: "Zoek op locatie",
                options: _vm.locationOptions
              },
              model: {
                value: _vm.location,
                callback: function($$v) {
                  _vm.location = $$v
                },
                expression: "location"
              }
            }),
            _vm._v(" "),
            _c("form-select", {
              staticClass: "w-full min-w-[200px] lg:max-w-[250px] text-orange",
              attrs: {
                placeholder: "Zoek op functie",
                options: _vm.jobOptions
              },
              model: {
                value: _vm.job,
                callback: function($$v) {
                  _vm.job = $$v
                },
                expression: "job"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "font-semi text-18 flex-none" }, [
          _vm._v(
            "We hebben " +
              _vm._s(_vm.localVacancies.length) +
              " resultaten gevonden"
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-24 lg:gap-[50px]" },
      _vm._l(_vm.localVacancies, function(vacancy, index) {
        return _c("VacancyCard", { key: index, attrs: { vacancy: vacancy } })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }